import * as React from "react";
import { observer } from "mobx-react";

import "./FilterBlock.less"

// imported only for typings
// these are passed to the component from index.ts
import { Carousel, CarouselItem } from "./components";
import { sportViewConfig } from "./config";
import { IStateView, ModelItem } from "../../common";

// external components
// import * as CMP from "./components";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the FilterBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

type FilterBlockProps = {
    state: IStateView<ModelItem>,
    config: sportViewConfig
}

@observer
export class FilterBlock extends React.Component<FilterBlockProps> {

    constructor(props: FilterBlockProps) {
        super(props);
    }

    render() {
        const className = this.props.state.isEventView ? "rj-filter-block--side-panel" : "";
        const config = { ...this.props.config, iconSize: this.props.state.isEventView ? "24" : this.props.config.iconSize };

        return (
            <div className={className}>
                <Carousel>
                    {
                        this.props.state.Items.map((item, index) =>
                            <CarouselItem
                                key={`item-${index}`}
                                item={item}
                                config={config}
                                handler={() => this.props.state.selectItem(item)}
                                isSelected={this.props.state.SelectedItemId === item.id}
                            />
                        )
                    }
                </Carousel>
                {/*process.env.NODE_ENV === "development" && (
                    <DevTools />
                )*/}
            </div>
        )
    }
}